/**
 * Official store listings for the Yum Express customer app — the one place
 * the web links to them from. Values match the customer app
 * (yum-express-app/src/services/updateService.ts: IOS_APP_ID 6752542317,
 * ANDROID_PACKAGE com.yumexpress.yum_express) and the backend's app-update
 * endpoint. Override per deployment with REACT_APP_APP_STORE_URL /
 * REACT_APP_GOOGLE_PLAY_URL.
 */
export const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/us/app/yum-express/id6752542317'
export const GOOGLE_PLAY_URL = process.env.REACT_APP_GOOGLE_PLAY_URL || 'https://play.google.com/store/apps/details?id=com.yumexpress.yum_express'

/** Public site origin, for canonical URLs and share metadata. */
export const SITE_URL = 'https://yum-express.com'
